export const styles = {
  selectContainer: {
    width: "100%",
    position: "relative" as const,
  },
  select: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    border: "1px solid #E2E2FC",
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "1rem",
    outline: "none",
    textOverflow: "ellipses",
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: "1.1876em",
    letterSpacing: "0.00938em",
    cursor: "pointer",
    boxSizing: "border-box" as const,
    // Legacy MUI JSS reads its own palette, not the shadcn `--sds-*` tokens, so it
    // never flipped under `.dark` — the selected value rendered near-black on the
    // dark field (PAD-31784). Re-point only in dark; light stays pixel-identical.
    ".dark &": {
      color: "hsl(var(--sds-foreground))",
      borderColor: "hsl(var(--sds-input))",
    },
  },
  iconsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  optionsContainer: {
    display: "flex",
    flexWrap: "wrap" as const,
    justifyContent: "space-between",
    position: "absolute" as const,
    width: "100%",
    top: "35px",
    left: 0,
    border: "1px solid #E2E2FC",
    borderRadius: "8px",
    padding: "12px 12px 0 12px",
    backgroundColor: "#FFFFFF",
    zIndex: 999,
    // Without this the dropdown surface stayed white in dark mode, so the
    // (already dark-aware) FlyerTypeCard items rendered on a white island.
    ".dark &": {
      backgroundColor: "hsl(var(--sds-popover))",
      borderColor: "hsl(var(--sds-input))",
    },
  },
  currencySigns: {
    color: "#AEAFC7",
    marginRight: "8px",
    ".dark &": {
      color: "hsl(var(--sds-muted-foreground))",
    },
  },
  scrollable: {
    maxHeight: "calc(30vh - 25px)",
    overflowY: "auto" as const,
  },
};
